<template>
  <v-content>
    <v-portal-tool-bar/>
    <v-img
      :src="mainImage"
      gradient="to top right, rgba(0,0,0,.5), rgba(0,0,0,.8)"
      :height="mainImageHeight"
      :contain="isMobile"
    >
      <v-container
        fill-height
        class="main--text"
      >
        <v-row
          justify=end
          align=center
        >
          <v-col
            md=12
          >
            <v-row
            >
              <div :class="headingTextContainerStyle">
                <h1
                  class="white--text title--text"
                  :class="headingTextStyle"
                >
                  Prosenseが提供する<br>プログラミング学習用<br>ビデオ講義シリーズ
                </h1>
              </div>
            </v-row>
          </v-col>
        </v-row>
      </v-container>
    </v-img>
    <v-container>
      <v-row
        justify=center
        align=center
      >
        <v-col cols=12>
          <h3 class="text-center font-weight-black">ビデオ講義シリーズ一覧</h3>
        </v-col>
      </v-row>
    </v-container>
    <v-container
      class="main--text"
      fluid>
      <v-row
        justify=space-around
      >
        <v-col
          md=4
          cols=12
        >
          <VProsenseGuidance/>
        </v-col>
        <v-col
          md=4
          cols=12
        >
          <VMineCraft/>
        </v-col>
      </v-row>
    </v-container>
    <v-portal-footer/>
  </v-content>
</template>

<script>
import MainImage from '@/assets/img/video-lessons/video-lesson-main.jpg'
import VSectionBar from '@/components/molecules/VSectionBar.vue'
import VPortalToolBar from '@/components/organisms/portal/VPortalToolBar.vue'
import VPortalFooter from '@/components/organisms/portal/VPortalFooter.vue'
import VToContactIcon from '@/components/organisms/portal/VToContactIcon.vue'
import VProsenseGuidance from '@/components/organisms/portal/videolessons/VProsenseGuidance.vue'
import VMineCraft from '@/components/organisms/portal/videolessons/VMineCraft.vue'


export default {
  components: {
    VPortalToolBar,
    VPortalFooter,
    VToContactIcon,
    VSectionBar,
    VProsenseGuidance,
    VMineCraft,
  },
  data: () => {
    return {
      mainImage: MainImage
    }
  },
  computed: {
    isMobile() {
      return this.$vuetify.breakpoint.xs
    },
    headingTextStyle() {
      return {
        'heading-text': !this.isMobile,
        'heading-text-mobile': this.isMobile
      }
    },
    headingTextContainerStyle() {
      return {
        'heading-text-container-mobile': this.isMobile
      }
    },
    mainImageHeight() {
      return this.isMobile ? null : 700
    }
  }
}
</script>

<style scoped>

.heading-text {
  font-size: 4.0rem;
  letter-spacing: 5px;
}

.heading-text-mobile {
  font-size: 1.5rem;
  letter-spacing: 3px;
}

.heading-text-container-mobile {
  padding: 10px;
}
</style>

